import React, { Fragment, useState } from 'react';
import { useQueryClient } from 'react-query';
import _ from "underscore";
import { Select, MenuItem, Grid } from "@material-ui/core";
import { MaskedNumber } from "../../../controls";
import CurrencyLookup from "../../Currencies/components/CurrencyLookup"
import UomLookup from "../../Settings/components/UomLookup";
import { useExchangeRateConversion } from "../../../services/currencies";

const UnitPrice = props => {
  const [state, setState] = useState({    
    amount: props.amount,
    currencyCode: (props.currencyCode ? props.currencyCode : props.defaultCurrencyCode ? props.defaultCurrencyCode : "USDC"),
    conversionCurrencyCode: props.conversionCurrencyCode ? props.conversionCurrencyCode : 'USDC',
    conversionDate: props.conversionDate ? props.conversionDate : '0001-01-01',
    conversionRateProviderCode: props.conversionRateProviderCode ? props.conversionRateProviderCode : 'SYSTEM',
    convertedValue: props.convertedValue,
    uom: (props.uom ? props.uom : props.defaultUom ? props.defaultUom : "USG"),
    defaultCurrencyCode: props.defaultCurrencyCode,
    defaultUom: props.defaultUom,
    usgConversionFactor: 1
  });
  const queryClient = useQueryClient();

  const conversion = useExchangeRateConversion({queryClient, extraKeys: [state.conversionRateProviderCode, state.currencyCode, state.conversionCurrencyCode, state.conversionDate] });

//  console.log(state);

  const handleAmountChange = (value) => {
    let conversionFactor = conversion && conversion.data && conversion.data.conversionFactor > 0 ? conversion.data.conversionFactor : 1;
    let convertedValue = (props.value * conversionFactor).toFixed(props.decimalScale || 3);
    setState({...state, amount: value, convertedValue});
    props.onChange({ ...state, amount: value, action: "amount", convertedValue });    
  };

  const handleCurrencyChange = obj => {
    let conversionFactor = conversion && conversion.data && conversion.data.conversionFactor > 0 ? conversion.data.conversionFactor : 1;
    let convertedValue = (props.value * conversionFactor).toFixed(props.decimalScale || 3);
    setState({...state, currencyCode: obj.value});
    props.onChange({...state, currencyCode: obj.value, currencyData: obj, action: "currency", convertedValue});
  };

  const handleUomChange = uom => {
    let conversionFactor = conversion && conversion.data && conversion.data.conversionFactor > 0 ? conversion.data.conversionFactor : 1;
    let convertedValue = (props.value * conversionFactor).toFixed(props.decimalScale || 3);

    if (uom.found)
      setState({...state, uom: uom.value, usgConversionFactor: uom.data.factor});
    else
      setState({...state, uom: uom.value});
    props.onChange({...state, uom: uom.value, action: "uom", convertedValue, usgConversionFactor: uom.data.factor});
  };

  return (
    <Fragment>
      <Grid
        container
        direction="row"
        justify="flex-end"
      >
        <Grid item xs style={{ minWidth:70 }}>
          <CurrencyLookup
            width={70}
            returnType="object"
            showChildCurrencies={true}
            value={state.currencyCode}
            onChange={handleCurrencyChange}
            style={{ fontSize: "0.875rem", ...props.currencyStyle}}
          />
        </Grid> 
        <Grid item xs style={{ minWidth:70 }}>
          <MaskedNumber
            value={state.amount}
            decimalScale={3}
            fixedDecimalScale={true}
            onChange={handleAmountChange}
            style={{fontSize: "0.875rem", ...props.style}}
          />
        </Grid>
        <Grid item xs style={{ minWidth:55 }}>
          <UomLookup
            returnType={"object"}
            value={state.uom}
            onChange={handleUomChange}
          />
        </Grid>
      </Grid>
    </Fragment>
  )
};

export default UnitPrice;